import {
  Component, effect,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild,
  ChangeDetectorRef
} from '@angular/core';
import {NavigationEnd, Router, RouterOutlet} from '@angular/router';
import {environment} from '../../../../environments/environment';
import {TranslocoModule} from '@jsverse/transloco';
import {LayoutModule} from '../../../core/modules/layout-module';
import {filter, Subscription} from 'rxjs';
import {SidebarPartial} from '../../../core/directives/layout/sidebar/sidebar-partial';
import {HeaderPartial} from '../../../core/directives/layout/header/header-partial';
import {LayoutService} from '../../../core/services/layout.service';
import {ToastModule} from 'primeng/toast';
import {BreadcrumbLayoutDirective} from '../../../core/directives/layout/breadcrumb/breadcrumb.layout.directive';
import {TitleLayoutDirective} from '../../../core/directives/layout/title/title.layout.directive';
import {BreakpointDebugComponent} from '../../../core/components/debug/breakpoint-debug.component';
import {LayoutDebugComponent} from '../../../core/components/debug/layout-debug.component';
import {JsonPipe, NgClass} from '@angular/common';
import {SidebarJplusPartial} from '../../../core/directives/layout/sidebarJplus/sidebarJplus-partial';
import {SinistreSliderPartial} from '../../../modules/DOnet/directives/partials/sinistreSlider/sinistreSlider.partial';
import {AutoDetectPrintPdfDirective} from '../../../core/directives/auto-print-pdf.directive';
import { MemoryDebugComponent } from '../../../core/components/debug/memory-debug.component';

@Component({
  selector: 'app-logged-layout',
  templateUrl: './logged-layout.html',
  imports: [
    TranslocoModule,
    LayoutModule,
    ToastModule,
    RouterOutlet,
    BreadcrumbLayoutDirective,
    TitleLayoutDirective,
    BreakpointDebugComponent,
    LayoutDebugComponent,
    NgClass,
    SidebarJplusPartial,
    SinistreSliderPartial,
    AutoDetectPrintPdfDirective,
    MemoryDebugComponent
  ],
  standalone: true
})

export class LoggedLayout implements OnInit, OnDestroy {

  overlayMenuOpenSubscription: Subscription;
  menuOutsideClickListener: any;

  @ViewChild(SidebarPartial) appSidebar!: SidebarPartial;
  @ViewChild(HeaderPartial) appTopBar!: HeaderPartial;

  constructor(
    public layoutService: LayoutService,
    public renderer: Renderer2,
    public router: Router,
    private cdr: ChangeDetectorRef
  ) {

    this.overlayMenuOpenSubscription = this.layoutService.overlayOpen$.subscribe(() => {
      if (!this.menuOutsideClickListener) {
        this.menuOutsideClickListener = this.renderer.listen('document', 'click', (event) => {
          if (this.isOutsideClicked(event)) {
            this.hideMenu();
          }
        });
      }

      if (this.layoutService.isMobileMenuOpen()) {
        this.blockBodyScroll();
      }
    });

    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      this.hideMenu();
    });

  }

  ngOnInit() {

  }

  isOutsideClicked(event: MouseEvent) {
    const sidebarEl = document.querySelector('.sidebar');
    const topbarEl = document.querySelector('#menuToggleMobile');
    const eventTarget = event.target as Node;

    return !(sidebarEl?.isSameNode(eventTarget) || sidebarEl?.contains(eventTarget) || topbarEl?.isSameNode(eventTarget) || topbarEl?.contains(eventTarget));
  }

  hideMenu() {
    this.layoutService.closeMobileMenu();
    if (this.menuOutsideClickListener) {
      this.menuOutsideClickListener();
      this.menuOutsideClickListener = null;
    }
    this.unblockBodyScroll();
  }

  blockBodyScroll(): void {
    if (document.body.classList) {
      document.body.classList.add('blocked-scroll');
    } else {
      document.body.className += ' blocked-scroll';
    }
  }

  unblockBodyScroll(): void {
    if (document.body.classList) {
      document.body.classList.remove('blocked-scroll');
    } else {
      document.body.className = document.body.className.replace(new RegExp('(^|\\b)' + 'blocked-scroll'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    }
  }

  ngOnDestroy() {
    if (this.overlayMenuOpenSubscription) {
      this.overlayMenuOpenSubscription.unsubscribe();
    }

    if (this.menuOutsideClickListener) {
      this.menuOutsideClickListener();
    }
  }

  protected readonly environment = environment;
}
